module.exports = __webpack_public_path__ + "static/img/3.520f041.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/eng/3.png
// module id = nib3
// module chunks = 0